<template>
  <div class="app-option-detail" :class="{'service-detail': isService}">
     <div :class="'left-space ' + type" v-if="!isService">
        <div class="option-image">
          <img :src="option_.image" alt="Option">
        </div>
        <div id="documents">
          <p><a class="arrowred" :href="option_.priceTable">Preistabelle (PDF) herunterladen</a></p>
          <p v-if="isDocumentUrl && option_.option.automaticExtension === true">
            Die Vertragszusammenfassung finden Sie <a @click="download()" class="arrowred" target="_blank"><slot name="txtDocument">hier</slot></a>.
          </p>
        </div>
        <div >
          <Stepper :showNext="false" @prev="back()">
          </Stepper>
        </div>
      </div>
      <div class="right-space" :class="{'service-space': isService}">
        <p class="headline" v-html="option_.name"></p>
        <div  v-if="type === 'book'" class="option-description">
          <div class="description-content">
            <slot  name="txtBookService" v-if="isService"></slot>
            <slot  :name="`txtBook${option_.id}`" v-else></slot>
          </div>
        </div>
        <div  v-if="type === 'cancel'" class="option-description-cancel">
          <div class="description-content">
            <slot  name="txtCancelService" v-if="isService"></slot>
            <slot  :name="`txtCancel${option_.id}`" v-if="!isService"></slot>
          </div>
        </div>
        <div class="balance-info" v-if="type === 'book' && !isService">
          <BalanceInfo :optionPrice="option_.option.price" :showButton="true" :balance="balance">
            <template v-for="slot in possibleChildSlotsFor('Balance')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </BalanceInfo>
        </div>
        <div class="footer-content" v-if="type === 'book'">
          <div class="option-incentive">
            <div class="days" v-if="isService" v-html="option_.duration"></div>
            <div class="days" v-if="!isService"><p class="duration">{{option_.option.duration.amount}} / {{durationUnit(option_.option.duration.unit, option_.option.duration.amount)}}</p></div>
            <div class="amount" v-if="!isService" ><p class="price">{{option_.option.formattedPrice}}</p></div>
            <div class="amount" v-if="isService" ><p class="price"><slot  name="txtFreeFee">kostenlos</slot></p></div>
            <b-overlay  class="btn-next-overlay" :show="loadingNext" spinner-small>
              <b-button @click="book" :disabled="loadingNext" :class="'btn-next btn-green'" type="button" variant="primary" >
                <slot  name="btnBook" v-if="!isService">Jetzt kostenpflichtig buchen</slot>
                <slot  name="btnBook" v-if="isService">Aktivieren</slot>
              </b-button>
            </b-overlay>
            <div v-if="isService" class="btn-service-back">
              <Stepper :showNext="false" @prev="back()">
              </Stepper>
            </div>
          </div>
        </div>
        <div class="footer-content-cancel" v-if="type === 'cancel'">
            <b-overlay  class="btn-next-overlay" :show="loadingNext" spinner-small>
              <b-button @click="cancel" :disabled="loadingNext" :class="'btn-next'" id="cancel-options-button" type="button" variant="primary" >
                <slot  name="btnCancel" v-if="!isService">Kündigen</slot>
                <slot  name="btnCancel" v-if="isService">deaktivieren</slot>
              </b-button>
            </b-overlay>
        </div>
      </div>
    </div>
</template>

<script>

import Stepper from '../../../../generic/Stepper.vue'
import BalanceInfo from '../lidl/BalanceInfo.vue'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
import axios from 'axios'
import FileSaver from 'file-saver'
import slotProxy from '@/mixins/slotProxy'
import durationUnit from '../../../../../mixins/durationUnit'

export const stepName = 'detail'

export default {
  name: 'OptionDetail',
  data () {
    return {
      currentCustomer: null,
      loadingNext: false
    }
  },
  components: { BalanceInfo, Stepper },
  computed: {
    balance: function () {
      return this.currentCustomer?.balance
    },
    isDocumentUrl: function () {
      return this.option.response !== null && ((this.option.response?.bookTariffoptionDocumentUrl !== '' || this.option.response?.bookTariffoptionDocumentUrl !== null) || (this.option.response?.cancelTariffoptionDocumentUrl !== '' || this.option.response?.cancelTariffoptionDocumentUrl !== null))
    },
    option_: function () {
      return this.option
    },
    isService: function () {
      return this.option.type === 'service'
    },
    serviceStatus: function () {
      if (this.option.type === 'service' && this.option.serviceOption?.anonymousCallRejection) {
        return 'active'
      }
      return 'inactive'
    },
    ...mapGetters([
      'accessToken'
    ])
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    },
    prevStep: {
      type: String,
      default: 'viewOptions'
    }
  },
  mixins: [
    slotProxy(),
    transaction('bookTariffOptions'),
    durationUnit
  ],
  methods: {
    download: function () {
      const me = this
      let url = ''
      if (this.type === 'book') {
        url = this.option_.response?.bookTariffoptionDocumentUrl
      } else {
        url = this.option_.response?.cancelTariffoptionDocumentUrl
      }
      axios.get(url, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/pdf'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: response.headers['content-type'] })
        FileSaver.saveAs(file, 'Vertragszusammenfassung.pdf')
      }).catch((reason) => {
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    },
    ...mapActions('bookTariffOptions', [
      'confirmTariffoption', 'deactivateTariffOption', 'updateServiceOption', 'cancelTariffOptionConfirm'
    ]),
    async book () {
      if (!this.isService) {
        this.loadingNext = true
        await this.confirmTariffoption()
        this.loadingNext = false
      } else {
        this.loadingNext = true
        await this.updateServiceOption(true)
        this.loadingNext = false
      }
    },
    async cancel () {
      if (!this.isService) {
        this.loadingNext = true
        await this.cancelTariffOptionConfirm()
        this.loadingNext = false
      } else {
        this.loadingNext = true
        await this.updateServiceOption(false)
        this.loadingNext = false
      }
    },
    ...mapMutations('bookTariffOptions', [
      'changeStep'
    ]),
    back () {
      this.changeStep(this.prevStep)
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query balanceInfo {
        currentCustomer {
          balance
          contract {
            msisdn
          }
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
